/**
 * @generated SignedSource<<49796c0fd7e77142c01c8d3e78ace293>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CourseCardCourseNote_course$data = {
  readonly facility: {
    readonly id: string;
  };
  readonly " $fragmentType": "CourseCardCourseNote_course";
};
export type CourseCardCourseNote_course$key = {
  readonly " $data"?: CourseCardCourseNote_course$data;
  readonly " $fragmentSpreads": FragmentRefs<"CourseCardCourseNote_course">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CourseCardCourseNote_course",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Facility",
      "kind": "LinkedField",
      "name": "facility",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Course",
  "abstractKey": null
};

(node as any).hash = "e5a98b6d072ddc589501d93aac3e7296";

export default node;
